import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, onLogout }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        onLogout();
        navigate('/');
    };

    return (
        <nav className="navbar">
            <div className="navbar-content">
                <Link to="/" className="navbar-logo">
                    <img src="/logo.svg" alt="NeuAIs" className="logo-image" />
                    <span className="logo-text"><strong>NeuAIs</strong></span>
                </Link>

                <div className="navbar-links">
                    <Link to="/dashboard" className="nav-link">
                        <img src="/svg/grey-table-left.svg" alt="" className="nav-icon" />
                        <span>Dashboard</span>
                    </Link>
                    <Link to="/calendar" className="nav-link">
                        <img src="/svg/graph.svg" alt="" className="nav-icon" />
                        <span>Calendar</span>
                    </Link>
                    <Link to="/notebook" className="nav-link">
                        <img src="/svg/code.svg" alt="" className="nav-icon" />
                        <span>Notebook</span>
                    </Link>
                    <Link to="/ide" className="nav-link">
                        <img src="/svg/code.svg" alt="" className="nav-icon" />
                        <span>IDE</span>
                    </Link>
                    {user?.role === 'admin' && (
                        <Link to="/admin" className="nav-link">
                            <img src="/svg/cog.svg" alt="" className="nav-icon" />
                            <span>Admin</span>
                        </Link>
                    )}
                </div>

                <div className="navbar-user">
                    <div className="user-info">
                        <img src="/svg/database-cog.svg" alt="" className="user-icon" />
                        <span>{user?.name || 'User'}</span>
                    </div>
                    <button onClick={handleLogout} className="btn-icon" title="Logout">
                        <img src="/svg/arrow-down.svg" alt="Logout" />
                    </button>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
